import React from 'react';

// Brand colors
const BRAND = {
  navy: '#0B1E3D',
  saffron: '#D96000',
  saffronLight: '#FF9933',
  saffronGlow: '#FFB347',
  blue: '#1B4A9A',
  blueLight: '#4A8ED4',
  white: '#FFFFFF',
  grey: '#5C6B7A',
};

export function LogoIcon({ size = 48 }) {
  const id = `logo-${Math.random().toString(36).slice(2, 6)}`;
  return (
    <svg width={size} height={size} viewBox="-40 -40 80 80" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={`sg-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFB347"/>
          <stop offset="100%" stopColor="#D96000"/>
        </linearGradient>
      </defs>
      <circle r="38" fill="#0B1E3D"/>
      <circle r="35" fill="none" stroke="#2A6FC4" strokeWidth="1.5" opacity="0.5"/>
      <g className="animate-spin" style={{ animationDuration: '20s' }}>
        {[0,30,60,90,120,150,180,210,240,270,300,330].map(deg => (
          <line key={deg} x1="0" y1="-18" x2="0" y2="-33" stroke="#FF9933" strokeWidth="1.8" opacity="0.95" transform={`rotate(${deg})`}/>
        ))}
      </g>
      <circle r="16" fill="none" stroke={`url(#sg-${id})`} strokeWidth="2.2"/>
      <g className="animate-spin" style={{ animationDuration: '14s', animationDirection: 'reverse' }}>
        {[0,45,90,135,180,225,270,315].map(deg => (
          <circle key={deg} cy="-16" r="1.8" fill="#FF9933" transform={`rotate(${deg})`}/>
        ))}
      </g>
      <circle r="6.5" fill={`url(#sg-${id})`}/>
      <circle r="3" fill="#0B1E3D"/>
    </svg>
  );
}

export function UnderaiterMark({ size = "text-xl", dark = false }) {
  const baseColor = dark ? '#FFFFFF' : '#0B1E3D';
  return (
    <span className={`${size} select-none inline-flex items-baseline`} style={{ fontFamily: "Georgia, 'Times New Roman', serif", fontWeight: 700, letterSpacing: '-0.025em' }}>
      <span style={{ color: baseColor }}>under</span>
      <span style={{ background: 'linear-gradient(135deg, #FFC46B, #FF9A26, #F27500)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', filter: 'drop-shadow(0 0 5px rgba(255,154,38,0.55))' }}>AI</span>
      <span style={{ color: baseColor }}>ter</span>
      <span style={{ color: dark ? '#4A8ED4' : '#1B4A9A', fontWeight: 400 }}>.com</span>
    </span>
  );
}

export function AIRAMark({ size = "text-3xl", dark = false }) {
  const textColor = dark ? '#FFFFFF' : '#0B1E3D';
  return (
    <span className={`${size} tracking-[0.08em] uppercase font-bold select-none`} style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}>
      <span style={{ color: textColor }}>fr</span>
      <span style={{ background: 'linear-gradient(135deg, #FFC46B, #FF9A26, #F27500)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', filter: 'drop-shadow(0 0 4px rgba(255,154,38,0.5))' }}>AI</span>
      <span style={{ color: textColor }}>me</span>
    </span>
  );
}

export function AIRAMarkDark({ size = "text-3xl" }) {
  return <AIRAMark size={size} dark />;
}

export function Tagline({ dark = false, size = "text-[10px]" }) {
  return (
    <span className={`${size} uppercase tracking-[0.35em] font-bold select-none`} style={{ fontFamily: "'Courier New', monospace", color: dark ? '#FFFFFF' : '#0B1E3D' }}>
      Evolutionary Insurance Intelligence.
    </span>
  );
}

export function FullLogo({ dark = false, size = "md" }) {
  const iconSize = size === "lg" ? 48 : size === "md" ? 36 : 24;
  const textSize = size === "lg" ? "text-3xl" : size === "md" ? "text-2xl" : "text-lg";
  const tagSize = size === "lg" ? "text-[10px]" : size === "md" ? "text-[9px]" : "text-[7px]";
  return (
    <div className="flex items-center gap-3">
      <LogoIcon size={iconSize} />
      <div>
        <UnderaiterMark size={textSize} dark={dark} />
        <div className="mt-0.5"><Tagline dark={dark} size={tagSize} /></div>
      </div>
    </div>
  );
}

export { BRAND };
export const TAGLINE = 'Run your entire MGA on one platform.';
